module.exports = __webpack_public_path__ + "img/slash.81a73910.svg";